var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:{
    holder: true,
    component: !_vm.fullPage,
    fullPage: _vm.fullPage,
  },style:({
    paddingLeft: _vm.paddingLeft,
    paddingTop: _vm.paddingTop,
  })},[_c('span',{staticClass:"loading-content"},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"spinner","pulse":""}}),_c('span',{directives:[{name:"t",rawName:"v-t",value:('loading'),expression:"'loading'"}],staticClass:"text"})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }